<i18n src="@/lang/actions"></i18n>
<i18n>
    {
    "en": {
    "nothing_to_install": "Nothing to install"
    },
    "ua": {
    "nothing_to_install": "Нема що встановлювати"
    },
    "ru": {
    "nothing_to_install": "Нечего устанавливать"
    }
    }
</i18n>

<template>
  <div class="TYT">
    <el-row v-if="!showList">
      <el-col :span="12" :offset="6">
        <div>
          {{ $t("nothing_to_install") }}
          <el-button type="text" @click="$router.go(-1)"
            >{{ $t("actions.go_back") }}...</el-button
          >
        </div>
      </el-col>
    </el-row>
    <template v-else v-for="(script, i) in scripts">
      <el-card
        v-if="!skipCodeList.includes(script.code)"
        class="box-card"
        :body-style="{ padding: '0px 20px' }"
        :key="i"
      >
        <div
          slot="header"
          class="clearfix collapse-handler"
          @click.capture="() => handleClick(i)"
        >
          <el-row type="flex">
            <span>
              {{ script.code }}
            </span>
            <i
              class="el-collapse-item__arrow el-icon-arrow-right"
              :class="{ 'is-active': activeName === i }"
            >
            </i>
          </el-row>
        </div>
        <el-collapse-transition>
          <settings-block
            v-show="activeName === i"
            :script="script"
            :custom-fields="customFields"
            @onSave="handleSaveSharedScripts"
          />
        </el-collapse-transition>
      </el-card>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SharedScripts from "../../store/classes/SharedScripts";
import SettingsBlock from "./settings-block";

export default {
  name: "ScriptsList",
  components: { SettingsBlock },
  props: {
    allowedScripts: Object,
    skipCodeList: Array,
    customFields: Object
  },
  data: () => ({
    activeName: undefined,
    scripts: []
  }),
  created() {
    let t = SharedScripts.getSelfList(Object.values(this.allowedScripts));
    t.forEach(v => {
      v.initParams(this.$store.state.cache.allowed_scripts.script_params);
    });
    this.scripts = t;
  },
  methods: {
    handleClick(i) {
      this.activeName = this.activeName === i ? undefined : i;
    },
    handleSaveSharedScripts(...args) {
      this.$emit("save-script", args[0]);
    }
  },
  computed: {
    ...mapState({
      params: state => state.cache.allowed_scripts.script_params
    }),
    // cascaderOptions() {
    //     let f = (value, label, children = undefined) => {
    //         return { value, label, children };
    //     };
    //     let customFields = Object.keys(this.customFields).map(v => {
    //         return f(v, this.$t(`amo.entity.name.${v}`), this.customFields[v].map((vv) => {
    //             return f(vv.id, vv.name);
    //         }));
    //     });
    //     return { customFields };
    // },
    showList() {
      this.$log("FFF");
      let t = Object.values(this.scripts).filter(
        v => !this.skipCodeList.includes(v.code)
      );
      return Boolean(t.length);
    }
  }
};
</script>

<style scoped lang="stylus">
.collapse-handler
    cursor pointer

.el-icon-check
    &_installed
        color #008000
</style>
